/* custom.js -- Ringos projekteigener Override-Layer (Wonder-Theme).
   Ergaenzt/ueberschreibt Verhalten aus den Theme-Originalen, ohne diese
   direkt anzufassen. */

(function () {
  // Sticky Add-to-Cart (PDP): am Seitenanfang sichtbar, blendet aus sobald
  // der reguläre ATC-Button (".wt-product__add-to-cart") im Viewport ist,
  // und blendet danach wieder ein. Analog zum Verhalten bei Mania/Hupsi.
  // Die permanente Sichtbarkeit + das Ausblenden selbst steuert custom.css
  // ueber die Klasse "custom-sticky-buy--hide", die hier nur gesetzt wird.
  var stickyBar = document.querySelector('.wt-product__sticky-buy');
  var atcModule = document.querySelector('.wt-product__add-to-cart');

  if (stickyBar && atcModule) {
    var stickyAtcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('custom-sticky-buy--hide', entry.isIntersecting);
      });
    });

    stickyAtcObserver.observe(atcModule);
  }
})();

/* Set-Konfigurator (snippets/set-configurator.liquid): Set-Positionen im
   Warenkorb nur komplett entfernen. Alle Zeilen mit gleicher _set_id auf 0. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-set-remove');
    if (!btn) return;
    event.preventDefault();
    var setId = btn.dataset.setId;
    if (!setId || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var item = btn.closest('.cart-item');
    if (item) item.style.opacity = '.4';
    var drawer = document.querySelector('cart-drawer');
    var drawerItems = document.querySelector('cart-drawer-items');

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (i) {
          if (i.properties && i.properties._set_id === setId) updates[i.key] = 0;
        });
        var body = { updates: updates };
        if (drawerItems && typeof drawerItems.getSectionsToRender === 'function') {
          body.sections = drawerItems.getSectionsToRender().map(function (s) { return s.section; });
          body.sections_url = window.location.pathname;
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (document.body.classList.contains('template-cart') || !drawerItems || !res.sections) {
          window.location.reload();
          return;
        }
        // gleiche Render-Logik wie CartDrawerItems.updateQuantity (assets/cart.js)
        drawerItems.getSectionsToRender().forEach(function (sec) {
          var html = res.sections[sec.section];
          var host = document.getElementById(sec.id);
          if (!html || !host) return;
          var target = host.querySelector(sec.selector) || host;
          var source = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector);
          if (source) target.innerHTML = source.innerHTML;
        });
        if (drawer) drawer.classList.toggle('is-empty', res.item_count === 0);
        drawerItems.classList.toggle('is-empty', res.item_count === 0);
        // bewusst kein publish(cartUpdate): CartItems.onCartUpdate würde sonst das Markup des Warenkorbs (Seite) in den Drawer schreiben
      })
      .catch(function () { window.location.reload(); });
  });
})();
